import { navWrapper } from '@mage-ui/styled-system/recipes';

export const NavWrapper = ({ children, a11yLabel, ...props }) => {
  return (
    <nav className={navWrapper()} aria-label={a11yLabel} {...props}>
      {children}
    </nav>
  );
};
